import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const baseUrl = '/secure/policies/purview/dlp-sensitive-information-type'

export const purviewSensitiveInfoTypeApi = createApi({
  reducerPath: 'purviewSensitiveInfoType',
  tagTypes: ['SensitiveInfoType', 'SensitiveInfoTypes'],
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getSensitiveInfoTypes: builder.query({
      query: (customerId) => ({
        url: baseUrl,
        params: { customerId },
      }),
      providesTags: (result, error, customerId) => [{ type: 'SensitiveInfoTypes', id: customerId }],
    }),
    getSensitiveInfoTypeById: builder.query({
      query: ({ customerId, policyId }) => ({
        url: `${baseUrl}/${policyId}`,
        params: { customerId },
      }),
      providesTags: (result, error, { policyId }) => [{ type: 'SensitiveInfoType', id: policyId }],
    }),
  }),
})

export const {
  useGetSensitiveInfoTypesQuery,
  useLazyGetSensitiveInfoTypesQuery,
  useGetSensitiveInfoTypeByIdQuery,
  useLazyGetSensitiveInfoTypeByIdQuery,
} = purviewSensitiveInfoTypeApi

export const useGetSensitiveInfoTypes = (options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetSensitiveInfoTypesQuery(customerId, options)
}

export const useGetSensitiveInfoTypeById = ({ policyId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetSensitiveInfoTypeByIdQuery({ customerId, policyId }, options)
}
